/**
 * Vuex store
 */
import Vue from 'vue'
import Vuex from 'vuex'
import * as mt from './mutation_types'

// ゲーム用データ
import { worldData } from "../assets/world/worldData.js"
import { questionDataW } from "../assets/world/questionData.js"
import { japanData } from "../assets/japan/japanData.js"
import { questionDataJ } from "../assets/japan/questionData.js"

// サウンドライブラリ
import SoundEffect from '../libs/SoundEffect.js'

// サウンドデータ
const roulette_stop = require("../assets/sounds/roulette_stop.mp3") // ルーレット停止音
const roulette = require("../assets/sounds/roulette.mp3") // ルーレット音
const popup = require("../assets/sounds/popup.mp3") // ポップアップ表示音
const bgm = require("../assets/sounds/bgm_sample.mp3")

Vue.use(Vuex)

/**
 * ゲーム用データおよび状態データ
 * 
 * <ul>
 * <li>worldData: 世界国別データ</li>
 * <li>japanData: 日本都道府県別データ</li>
 * <li>questionW: 世界質問データ</li>
 * <li>questionDataJ: 日本質問データ</li>
 * <li>firstProc: 最初の読み込みフラグ</li>
 * <li>currentQuestionIndex: 上級編のお題データのインデックス</li>
 * <li>currentGame: 現在表示中のView（メニューorルーレット）</li>
 * <li>soundsMute: 効果音ミュートフラグ</li>
 * <li>bgmMute: BGMミュートフラグ</li>
 * <li>currentViewWidth: 画面の幅</li>
 * <li>currentViewHeight: 画面の高さ</li>
 * <li>snd: サウンドオブジェクト</li>
 * </ul>
 */
const state = {
  worldData: worldData,
  japanData: japanData,
  questionDataW: questionDataW,
  questionDataJ: questionDataJ,
  firstProc: true,
  currentQuestionIndex: 0,
  currentGame: '',
  soundsMute: true,
  bgmMute: true,
  currentViewWidth: window.innerWidth,
  currentViewHeight: window.innerHeight,
  snd: new SoundEffect (
    new Audio(roulette),
    new Audio(roulette_stop),
    new Audio(popup),
    new Audio(bgm)
  )
}

/**
 * Actions
 */
const actions = {
  setFirstProc: ({ commit }, fc) => {
    commit(mt.SET_FIRST_PROC, fc)
  },
  setQuestionIndex: ({ commit }, idx) => {
    commit(mt.SET_QUESTION_INDEX, idx)
  },
  setCurrentGame: ({ commit }, game) => {
    commit(mt.SET_CURRENT_GAME, game)
  },
  setSounds: ({ commit }, sounds) => {
    commit(mt.SET_SOUNTDS_MUTE, sounds)
  },
  setBGM: ({ commit }, bgm) => {
    commit(mt.SET_BGM_MUTE, bgm)
  },
  setCurrentScreenSize: ({ commit }, payload) => {
    commit(mt.SET_CURRENT_SCREEN_SIZE, payload)
  }
}

/**
 * Mutations
 */
const mutations = {
  [mt.SET_FIRST_PROC] (state, fc) {
    state.firstProc = fc.firstProc
  },
  [mt.SET_QUESTION_INDEX] (state, idx) {
    state.currentQuestionIndex = idx.idx
  },
  [mt.SET_CURRENT_GAME] (state, game) {
    state.currentGame = game.gameName
  },
  [mt.SET_SOUNTDS_MUTE] (state, sounds) {
    state.soundsMute = sounds.soundsMute
  },
  [mt.SET_BGM_MUTE] (state, bgm) {
    state.bgmMute = bgm.bgmMute
  },
  [mt.SET_CURRENT_SCREEN_SIZE] (state, payload) {
    state.currentViewWidth = payload.width
    state.currentViewHeight = payload.height
  }
}

/**
 * Getters
 */
const getters = {
  worldData: state => state.worldData,
  japanData: state => state.japanData,
  questionDataW: state => state.questionDataW,
  questionDataJ: state => state.questionDataJ,
  firstProc: state => state.firstProc,
  currentQuestionIndex: state => state.currentQuestionIndex,
  currentGame: state => state.currentGame,
  soundsMute: state => state.soundsMute,
  bgmMute: state => state.bgmMute,
  currentViewWidth: state => state.currentViewWidth,
  currentViewHeight: state => state.currentViewHeight,
  snd: state => state.snd
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})